import type { Route } from "@angular/router";

import { checkIfLoggedInFn, notExternalOrParticipatingEntity, pmoEntity } from "../../core/guards";
import { viewEmployeePulseDashboardPageGuards, viewEmployeePulsePageGuards } from "./_guards";

const loadDashboard = () =>
  import("./employee-pulse-dashboard/employee-pulse-dashboard").then((e) => e.EmployeePulseDashboardComponent);

export const EMPLOYEE_PULSE_ROUTES: Route[] = [
  {
    path: "employees-pulse",
    canActivate: [checkIfLoggedInFn],
    loadComponent: () => import("./employee-pulse").then((e) => e.EmployeePulseComponent),
    data: {
      title: "happiness_survey.title",
      breadcrumb: "happiness_survey.title",
    },
  },
  {
    path: "employees-pulse-dashboard",
    canActivate: [checkIfLoggedInFn, notExternalOrParticipatingEntity, ...viewEmployeePulseDashboardPageGuards],
    loadComponent: loadDashboard,
    data: {
      mode: "dashboard",
      title: "employee_pulse.dashboard.title",
      breadcrumb: "employee_pulse.dashboard.title",
    },
  },
];

export const EMPLOYEE_PULSE_CONSOLE_ROUTES: Route[] = [
  {
    path: "employees-pulse",
    canActivate: [checkIfLoggedInFn, pmoEntity, ...viewEmployeePulsePageGuards],
    data: {
      breadcrumb: { skip: true },
    },
    children: [
      {
        path: "",
        redirectTo: "manage",
        pathMatch: "full",
      },
      {
        path: "manage",
        loadComponent: () =>
          import("./employee-pulse-manage/employee-pulse-manage").then((e) => e.EmployeePulseManageComponent),
        data: {
          title: "employee_pulse.manage.logs",
          breadcrumb: "employee_pulse.manage.logs",
        },
      },
      {
        path: "preview/:year/:quarter",
        loadComponent: loadDashboard,
        data: {
          mode: "preview",
          title: "employee_pulse.manage.preview",
          breadcrumb: "employee_pulse.manage.preview",
        },
      },
    ],
  },
];
